import { portalAPI } from './portalAPI';

const APITiqTimeSlice = portalAPI.enhanceEndpoints({ addTagTypes: ['TiqTime'] }).injectEndpoints({
    endpoints: (builder) => ({
        isTiqTimeEnabled: builder.query<boolean, void>({
            query: () => ({
                url: '/v1/integrations/tiqtime/enabled',
            }),
            providesTags: ['TiqTime'],
        }),
        getFrontendUrl: builder.query<string, void>({
            query: () => ({
                url: '/v1/integrations/tiqtime/frontend-url',
                responseHandler: 'text',
                headers: {
                    Accept: 'text/plain',
                },
            }),
            providesTags: ['TiqTime'],
        }),
        getUnpostedMinutes: builder.query<number, void>({
            query: () => ({
                url: '/v1/integrations/tiqtime/unposted-minutes',
            }),
            providesTags: ['TiqTime'],
        }),
        syncMatters: builder.mutation<void, number | undefined>({
            query: (limit) => ({
                url: '/v1/integrations/tiqtime/matters/sync',
                method: 'POST',
                params: limit !== undefined ? { limit } : {},
            }),
            invalidatesTags: ['TiqTime'],
        }),
        isMatterSyncInProgress: builder.query<boolean, void>({
            query: () => '/v1/integrations/tiqtime/matters/sync/in-progress',
            providesTags: ['TiqTime'],
        }),
    }),
    overrideExisting: false,
});

export const {
    useIsTiqTimeEnabledQuery,
    useGetFrontendUrlQuery,
    useGetUnpostedMinutesQuery,
    useSyncMattersMutation,
    useIsMatterSyncInProgressQuery,
    useLazyIsMatterSyncInProgressQuery,
} = APITiqTimeSlice;
